module.exports = __webpack_public_path__ + "img/Transnistria.37a97b37.png";